import { render, staticRenderFns } from "./ManterAvaliacaoFormacaoView.vue?vue&type=template&id=10529cdc"
import script from "./ManterAvaliacaoFormacaoView.vue?vue&type=script&lang=js"
export * from "./ManterAvaliacaoFormacaoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports